//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { maxLength, required, email } from 'vuelidate/lib/validators'
import LoadingButton from '@/components/ui/LoadingButton'
import TextareaGroup from '@/components/form/TextareaGroup'
import InputGroup from '@/components/form/InputGroup'
import Captcha from '@/mixins/Captcha'
import AxiosErrorHandler from '@/mixins/AxiosErrorHandler'
import HCaptchaInput from '@/components/form/HCaptchaInput'

export default {
  name: 'ContactForm',
  components: {
    HCaptchaInput,
    InputGroup,
    TextareaGroup,
    LoadingButton
  },
  mixins: [Captcha, AxiosErrorHandler],
  data () {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        text: '',
        token: null
      },
      sending: false
    }
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(100)
      },
      email: {
        required,
        email
      },
      subject: {
        required,
        maxLength: maxLength(100)
      },
      text: {
        required,
        maxLength: maxLength(10000)
      }
    }
  },
  methods: {
    async submit () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.sending = true

        try {
          await this.$axios.post('/utils/contact', this.form)

          await this.$store.dispatch('ui/showNotification', {
            type: 'success',
            text: this.$t('contact.sent')
          })

          this.sending = false
        } catch (err) {
          await this.handleError(err)

          this.sending = false
        }
      }
    }
  }
}
